module.exports = __webpack_public_path__ + "img/sunfeng.8c13d6d8.jpg";